export const JUNIPER_SUPPORT_EMAIL = 'support@junipergarden.co'
export const JUNIPER_LOGIN_URL = 'https://www.junipertechnology.co/login'
export const ANDROID_DOWNLOAD_LINK = 'https://play.google.com/store/apps/details?id=com.daashcraft.junipergardenmobile'
export const IOS_DOWNLOAD_LINK = 'https://apps.apple.com/app/juniper-technology/id1608728584'